module.exports = __webpack_public_path__ + "static/media/ativo.0119a08c.svg";